import { inject, Injectable, PLATFORM_ID } from '@angular/core';
import { DOCUMENT, isPlatformBrowser } from '@angular/common';

@Injectable({
  providedIn: 'root'
})
export class CookiesConsentService {
  private readonly platformId = inject(PLATFORM_ID);
  private document = inject(DOCUMENT);

  /**
   * Checks whether the user has accepted cookies.
   * Looks for "_tt_enable_cookie=1" in document.cookie.
   */
  hasAcceptedCookies(): boolean {
    return isPlatformBrowser(this.platformId)
      ? this.document.cookie.split(';').some((cookies) => cookies.trim().startsWith('_tt_enable_cookie=1'))
      : false;
  }
}
